var onloadCallback = function() {
  grecaptcha.render('html_element', {
    'sitekey' : '6Lf5ZaUpAAAAAOy-wfuxkzGeDoPCi725FOjZz5L5'
  });
};
window.addEventListener("load", function (event) {
  const suscribeButton = document.querySelector(".ff-button-register");
  const errorCaptcha = document.querySelector("#ff-captcha-error");
  suscribeButton.addEventListener("click", (e) => {
    const recaptcha_box_checked = (grecaptcha.getResponse()) ? true : false;
    if (!recaptcha_box_checked) { 
      e.preventDefault();  
      errorCaptcha.classList.remove("ff-hide-efect");
      errorCaptcha.classList.add("ff-captcha-error-effect");
    }
  })
});
